import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import {
  FaFan,
  FaWind,
  FaCog,
  FaLink,
  FaWrench,
  FaFire,
  FaEye,
  FaFilter,
  FaBox,
  FaScrewdriver,
  FaList,
  FaStar,
  FaSpinner
} from 'react-icons/fa';
import { API_URL } from '../config';
import './CategoryCollections.css';

const CategoryCollections = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const categoryIcons = {
    'Access & Inspection': FaEye,
    'Dampers': FaCog,
    'Fans & Ancils': FaFan,
    'Flexible Ducting': FaWind,
    'Grilles & Diffusers': FaFilter,
    'Spiral Duct & Fittings': FaSpinner,
    'Support & Ancil': FaWrench,
    'Tape & Sealant': FaLink,
    // Legacy mappings
    'Fans': FaFan,
    'Fans and ancils': FaFan,
    'Ducting': FaList,
    'Flexible ducting': FaWind,
    'Spiral duct and fittings': FaSpinner,
    'Vents': FaWind,
    'Grilles and diffusers': FaFilter,
    'Fittings': FaLink,
    'Mounting & Support': FaWrench,
    'Support and ancil': FaWrench,
    'Fire Protection': FaFire,
    'Filters': FaFilter,
    'Kits': FaBox,
    'Tape and sealant': FaLink,
    'Accessories': FaScrewdriver
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(API_URL + '/products/categories');
        if (response.ok) {
          const data = await response.json();
          setCategories(data.categories || []);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryName) => {
    navigate('/products?category=' + encodeURIComponent(categoryName));
  };

  const getIconForCategory = (categoryName) => {
    return categoryIcons[categoryName] || FaBox;
  };

  if (loading) {
    return (
      <div className="category-collections-loader text-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <section className="category-collections-section py-5">
      <Container>
        <div className="text-center mb-5">
          <h2 className="section-title">Shop by Category</h2>
          <p className="section-subtitle">
            Browse our comprehensive range of ventilation solutions
          </p>
        </div>

        <Row className="category-collections-grid">
          {categories.map((category) => {
            // Handle both string (legacy) and object (new hierarchy) formats
            const categoryName = typeof category === 'string' ? category : category.name;
            const IconComponent = getIconForCategory(categoryName);
            return (
              <Col
                key={categoryName}
                xs={6}
                sm={4}
                md={3}
                lg={2}
                className="mb-4"
              >
                <div
                  className="category-card"
                  onClick={() => handleCategoryClick(categoryName)}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCategoryClick(categoryName);
                    }
                  }}
                  aria-label={'Browse ' + categoryName}
                >
                  <div className="category-circle">
                    <IconComponent className="category-icon" />
                  </div>
                  <p className="category-name">{categoryName}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default CategoryCollections;
